//@ts-check
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { createGlobalStyle } from 'styled-components';

export const GlobalSkeletonStyles = createGlobalStyle`
  .skeleton_full_width_container {
    width: 100%;
    display: inline-block;
  }
`;
/**
 * @description A component that renders a skeleton loader if children are not provided. Example usage: <WithSkeleton count={3}>{!loading && <>loaded data</> }</WithSkeleton>
 * @param {import('react-loading-skeleton').SkeletonProps & React.PropsWithChildren<{isFullWidth?: boolean}>} props
 */
const WithSkeleton = ({ children, isFullWidth = false, containerClassName = '', ...skeletonProps }) => {
  const fullWidthClass = isFullWidth ? 'skeleton_full_width_container' : '';
  const containerClass = `${containerClassName} ${fullWidthClass}`.trim();

  return children || <Skeleton containerClassName={containerClass} {...skeletonProps} />;
};

export default WithSkeleton;
